module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAASCAYAAACEnoQPAAAAu0lEQVQ4jZ3TOwrCQBSF4T8ivirtXYQ7EKys3ICl9lqmczpbl+ACXIj2QRCsbNPoCq5cnQSRJPM4kBTDfLlnIJOIiBCZtmUX4BzwiSkwQb4xWiDgOahqxVbmp7amB6QextThXSx+ASMPXOZ/snHs12yrcBfYxOInkHj1rcB9YO+aVoebajtxSO2BvmL+sCWwArJQvACOwBWYhWCFJ+CmEMiLM8+BYQPsAGvgYffmn1V7JX1yF5FxeW1FeAPja3/8OggtWgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/ddgl.png
// module id = WhH+
// module chunks = 1